import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchAllPromotions } from '../../actions/Product';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import Status from '../../components/Status';

const $ = window.$;

class Promotions extends Component {

    componentDidMount() {

        this.props.fetchAllPromotions();

        // $(function () {
        //     $('[data-toggle="tooltip"]').tooltip();
        // });

        // $('#promotion-list').DataTable({
        //     searching: false,
        //     paginate: false,
        //     info: false,
        //     fixedColumns: true,
        //     bAutoWidth: false,
        //     columnDefs: [{
        //         width: 500,
        //         targets: 0
        //     },
        //     {
        //         width: 500,
        //         targets: 1
        //     },
        //     {
        //         width: 500,
        //         targets: 2
        //     },
        //     {
        //         width: 500,
        //         targets: 3
        //     },
        //     {
        //         width: 400,
        //         targets: 4
        //     }
        //     ],
        // });
    }

    onDeleteClick(promotion) {

    }

    renderPromotions() {
        const { promotions } = this.props;
        const rows = _.map(promotions, (promotion, key) => {
            console.log(promotion)
            return (
                <tr key={key}>
                    <td>{promotion.name_en}</td>
                    <td>Me nutra - Fish Oil</td>
                    <td>{`- ${promotion.discount_value}${promotion.discount_unit === 'percent' ? ' %' : ''}`}</td>
                    <td>
                        {promotion.status === 0 ? <Status color="green" title="Active" /> : <Status color="red" title="Inactive" />}
                    </td>
                    <td className="align-center">
                        <Link to={`/promotions/${key}`} className="btn btn-tooltip" data-toggle="tooltip" data-placement="top" title="Edit">
                            <img src="/resources/img/ic-edit.png" alt="Edit" data-toggle="modal" />
                        </Link>
                        <button 
                            className="btn btn-tooltip" 
                            data-toggle="tooltip" 
                            data-placement="top" 
                            title="Delete"
                            onClick={() => this.onDeleteClick(promotion)}
                        >
                            <img src="/resources/img/ic-delete.png" alt="Delete" />
                        </button>
                    </td>
                </tr>
            );
        });

        return (
            <tbody>
                {rows}
            </tbody>
        );
    }

    renderActions(promotion) {
        return (
            <div className="align-center">
                <Link to={`/promotions/${promotion.id}`} className="btn btn-tooltip" data-toggle="tooltip" data-placement="top" title="Edit">
                    <img src="/resources/img/ic-edit.png" alt="Edit" data-toggle="modal" />
                </Link>
                <button
                    className="btn btn-tooltip"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                    onClick={() => this.onDeleteClick(promotion)}
                >
                    <img src="/resources/img/ic-delete.png" alt="Delete" />
                </button>
            </div>
        );
    }

    renderTable() {
        const { promotions } = this.props;

        console.log(promotions);

        const data = _.toArray(promotions);

        return (
            <ReactTable
                data={data}
                columns={[
                    {
                        Header: 'Promotion',
                        id: 'promotion',
                        accessor: d => d.name_en
                    },
                    {
                        Header: 'Product',
                        id: 'product',
                        accessor: d => d.product_name,
                        width: 150
                    },
                    {
                        Header: 'Value',
                        id: 'value',
                        accessor: d => `- ${d.discount_value}${d.discount_unit === 'percent' ? ' %' : ''}`,
                        width: 120
                    },
                    {
                        Header: 'Status',
                        id: 'status',
                        accessor: d => d.status === 0 ? <Status color="green" title="Active" /> : <Status color="red" title="Inactive" />,
                        width: 120
                    }, {
                        Header: '',
                        id: 'actionButton',
                        className: 'col-center',
                        accessor: d => this.renderActions(d),
                        width: 60
                    }
                ]}
                defaultPageSize={10}
                className="-highlight"
            />
        );
    }

    render() {
        return (
            <div className="main-content">
                <div className="page-title">Promotion</div>
                <div className="divider"></div>
                <div className="function">
                    <div className="row">
                        <div className="col-md-auto" style={{ width: '82.5%' }}></div>
                        <div className="col-md-auto">
                            <Link to={`/promotions/new`} className="btn button green-btn btn-add btn-link">+ New Promotion</Link>
                        </div>
                    </div>
                </div>
                {this.renderTable()}
                {/* <table id="promotion-list" className="table table-list hover" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Promotion</th>
                            <th>Product</th>
                            <th>Discount</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    {this.renderPromotions()}
                </table> */}
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { promotions, isPromotionLoading, isPromotionError, promotionError } = state.product;
    return { promotions, isPromotionLoading, isPromotionError, promotionError };
}

export default connect(mapStateToProps, {
    fetchAllPromotions
})(Promotions);


// WEBPACK FOOTER //
// ./src/views/promotions/index.js